export default __webpack_public_path__ + "static/media/PH.82657321.svg";